import '../node_modules/photoswipe/dist/photoswipe.css';
import '../node_modules/photoswipe/dist/default-skin/default-skin.css';
import './main.scss';
import './tailwind.css';

import Swiper from 'swiper';
import CookiesEuBanner from 'cookies-eu-banner';
import _, { isNumber } from 'lodash';
import $ from 'jquery';
import 'popper.js';
import 'bootstrap';
import bsCustomFileInput from 'bs-custom-file-input'
import { Chart, registerables } from 'chart.js';

import './js/photoswipe.js';

import morph from '@alpinejs/morph';
import Countable from 'countable';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import persist from '@alpinejs/persist'

import htmx from 'htmx.org';
window.htmx = htmx;

// Register Chart.js components
Chart.register(...registerables);
window.Chart = Chart;

Alpine.plugin(persist);
Alpine.plugin(collapse);
//Alpine.plugin(morph);

window.Alpine = Alpine;

window.toggleExtraFieldChecked = function (initial, condition) {
  return {
    value: initial,
    isOpen() {
      return condition(this.value);
    },
    init() {
      if (Array.isArray(initial)) {
        this.value = [...this.$el.querySelectorAll('[x-model="value"]:checked')].map(node => node.value);
      } else {
        let node = this.$el.querySelector('[x-model="value"]:checked');
        if (node) {
          this.value = node.value;
        }
      }
    },
  }
}

window.checkPostcode = function (data) {
  return {
    postcode: '',
    allowedCodes: data,
    isOpen() {
      console.log(this.postcode);
      return !this.allowedCodes.includes(this.postcode);
    },
    init() {
      let node = this.$el.querySelector('[x-model="postcode"]');
      if (node) {
        if (node.tagName === 'DIV') {
          this.postcode = node.innerText;
        } else {
          this.postcode = node.value;
        }
      }
    },
  }
}


window.toggleProjectClass = function (initial, labels, option_1, option_2) {
  const changeTexts = (value, el, key) => {
    const label = labels[value][key].label;
    const help_text = labels[value][key].help_text;

    let helpEl = el.querySelector('.form-text');
    let labelEl = el.querySelector('label');

    if (helpEl) {
      helpEl.innerHTML = help_text;
    }

    if (labelEl) {
      labelEl.innerHTML = label;
    }
  }

  return {
    project_class: initial,
    option() {
      if (this.project_class === option_1) return 1;
      if (this.project_class === option_2) return 2;
      return 0;
    },
    init() {
      if (Array.isArray(initial)) {
        this.project_class = [...this.$el.querySelectorAll('[x-model="project_class"]:checked')].map(node => node.value);
      } else {
        let node = this.$el.querySelector('[x-model="project_class"]:checked');
        if (node) {
          this.project_class = node.value;
        }
      }
      const textChanger = value => {
        if (this.option() in labels) {
          changeTexts(this.option(), this.$refs['company_name'], 'company_name');
          changeTexts(this.option(), this.$refs['description'], 'description');
          changeTexts(this.option(), this.$refs['project_upload'], 'project_upload');
          changeTexts(this.option(), this.$refs['project_links'], 'project_links');
        }
      }
      this.$watch('project_class', textChanger);
      textChanger();
    },
  }
}


window.toggleInnerExtraFieldChecked = function (initial, condition) {
  return {
    innerValue: initial,
    isOpen() { return condition(this.innerValue); },
    init() {
      if (Array.isArray(initial)) {
        this.innerValue = [...this.$el.querySelectorAll('[x-model="innerValue"]:checked')].map(node => node.value);
      } else {
        let node = this.$el.querySelector('[x-model="innerValue"]:checked');
        if (node) {
          this.innerValue = node.value;
        }
      }
    },
  }
}


window.toggleMultiFields = function (initial, condition, selectCondition) {
  return {
    innerValue: initial,
    isOpen() { return condition(this.innerValue); },
    isSelected() { return selectCondition(this.innerValue); },
    init() {
      if (Array.isArray(initial)) {
        this.innerValue = [...this.$el.querySelectorAll('[x-model="innerValue"]:checked')].map(node => node.value);
      } else {
        let node = this.$el.querySelector('[x-model="innerValue"]:checked');
        if (node) {
          this.innerValue = node.value;
        }
      }
    },
  }
}


window.toggleFeedBackField = function () {
  return {
    value: '',
    rating: null,
    open: false,
    isOpen() { return this.value || this.open; },
    init() {
      let node = this.$el.querySelector('[x-model="value"]');
      if (node) {
        this.value = node.value;
      }

      let rating = this.$el.querySelector('[x-model="rating"]:checked');
      if (rating) {
        this.rating = rating.value;
      }
    }
  }
}

window.toggleExtraFieldSelected = function (initial, condition) {
  return {
    value: initial,
    isOpen() {
      return condition(this.value);
    },
    init() {
      if (Array.isArray(initial)) {
        this.value = [...this.$el.querySelectorAll('[x-model="value"] option[selected]')].map(node => node.value);
      } else {
        this.value = this.$el.querySelector('[x-model="value"] option[selected]').value;
      }
    },
  }
}


window.TotalRating = function (initialRating) {
  // {rating: {'fgdfgg': {'rating': x, 'weight': x}}}
  return {
    rated() { return _.filter(_.values(this.rating), o => o.rating !== null); },
    count() {
      //console.log(this.rating);
      return this.rated().length;
    },
    total() {
      let totalWeights = 1; //_.sumBy(this.rated(), o => o.weight);
      let total = _.sumBy(this.rated(), o => o.weight * o.rating) / totalWeights;
      return total;
    },
    update(newRating) {
      // {label: 'fgdfgg', rating: x}
      if (newRating.label in this.rating) this.rating[newRating.label].rating = parseInt(newRating.rating)
    },
    ...initialRating
  }
}

window.trackRatingFields = function (fields, categories) {
  return {
    update() {
      this.subtotal = 0;
      this.total = 0;

      for (const cat of categories) {
        this[cat] = 0;
        for(var k in fields) {
          if (k.startsWith(cat)) {
            let value = this[k] ? 1 : 0;
            this[cat] += value;
            this.total += value;
            console.log(cat, k, value);
          }
        }
        if (this[cat] > 0) {
          this.subtotal += 1;
        }
      }
    },
    count() {
      return Object.keys(fields).length;
    },
    cats() {
      return categories.length;
    },
    init() {
      for (const k of categories) {
        this[k] = 0;
      }
      this.update();
    },
    total: 0,
    subtotal: 0,
    ...fields
  }
}

window.CountingField = function (limit, direction, ressource) {
  return {
    limit: limit,
    direction: direction || 'down',
    ressource: ressource || 'all',
    counter: 0,
    count() { return (this.direction === 'down') ? this.limit - this.counter : this.counter },
    reached() { return (this.direction === 'down') ? this.counter === 0 : this.counter >= this.limit },
    init() {
      let node = this.$refs.field;
      if (node) {
        Countable.on(node, counter => { this.counter = counter[this.ressource]})
      }
    }
  }
}

window.InlineForms = function (params) {
  return {
    template: null,
    add() {
      let container = document.getElementById(this.container);
      container.insertAdjacentHTML('beforeend', this.template(this.TOTAL_FORMS));
      this.TOTAL_FORMS++;
    },
    loadTemplate(id) {
      let template = document.getElementById(id);
      this.template = (id) => template.innerHTML.replace(/__prefix__/g, id).replace(/__number__/g, id + 1);
    },
  }
};

Alpine.store('preview', {
  active: null,
  fullscreen: false,
  app: {id: '', rank: '', name: ''},
  pages: [],

  setData(pages, app) {
    this.pages = pages;
    this.app = app;
    this.active = '#app';
  },

  activeUrl() {
    const active_page = this.pages.find(page => page.hash === this.active);
    return active_page ? active_page.url: null;
  },

  // rating-preview
});

const preview = Alpine.store('preview')

window.PreviewIframe = function () {
  return {
    init() {
      let that = this;
      Alpine.watch(
        'preview.active', () => that.$el.contentWindow.location.replace(preview.activeUrl())
      );
    }
  }
}


window.addEventListener('load', () => {
  try {
    var photogalleryOptions = {
      shareButtons: localizedShareButtons
    };
  } catch (ReferenceError) {
    var photogalleryOptions = {};
  }

  $.extend(photogalleryOptions, {
    itemFilter: function () {
      return $(this).parents('.slick-cloned').length === 0;
    },
    captionSelector: '.caption'
  });

  $('.gallery').photogallery(photogalleryOptions);

  bsCustomFileInput.init();

  $('#nav-tab a').on('click', function (e) {
    e.preventDefault()
    $(this).tab('show')
  });

  $('.popup__links').on('click', function (e) {
    e.preventDefault();
    var modal = $(this).data("target");
    $(modal).modal("show");
    $(modal + ' .modal-body').load(
      $(this).attr("href") + ' .text-page-container',
      function () {
      }
    );
  });


  $('body').scrollspy({
    target: '#navbar-main'
  });

  if ($('.swiper-slideshow .swiper-slide').length > 1) {

    var gallerySwiper = new Swiper('.swiper-slideshow', {
      slidesPerView: 1,
      speed: 500,
      navigation: {
        prevEl: '.swiper-slideshow__arrow--prev',
        nextEl: '.swiper-slideshow__arrow--next',
        disabledClass: 'swiper-slideshow__arrow--disabled',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
        clickable: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
    });

    $('.swiper-slideshow').hover(function (params) {
      gallerySwiper.autoplay.stop();
    }, function (e) {
      gallerySwiper.autoplay.start();
    });
  }

  var file = document.getElementById("id_moodboard");
  if (file) {
    file.onchange = function () {
      if (file.files.length > 0) {

        document.getElementsByClassName('file-name')[0].innerHTML = file.files[0].name;

      }
    };
  }
});

(function () {
  function CountableField(textarea) {
    var countDisplay = document.getElementById(textarea.id + "_counter");
    var countDown = false;
    var minCount, maxCount;
    if (textarea != null && countDisplay != null) {
      minCount = textarea.getAttribute("data-min-count");
      maxCount = textarea.getAttribute("data-max-count");

      Countable.on(textarea, updateCharatersLeft);
    }

    function updateCharatersLeft(counter) {
      var count = counter["all"];
      var left = maxCount - count;
      countDisplay.getElementsByClassName("text-count-current")[0].innerHTML = left;
      if (left < 0)
        countDisplay.className = "text-count text-is-over-max";
      else
        countDisplay.className = "text-count";
    }
  }

  document.addEventListener('DOMContentLoaded', function (e) {
    ;
    [].forEach.call(document.querySelectorAll('[data-count]'), CountableField)
  })
})()

// Statistics Timeline Component
window.statsTimeline = function() {
  let charts = {};
  return {
    loading: true,
    dataPoints: 0,
    chartData: null,
    industryStacked: false,
    employeeStacked: true,

    init() {
      // Watch for changes to toggle stacked views
      this.$watch('industryStacked', () => {
        this.updateIndustryChart();
      });

      this.$watch('employeeStacked', () => {
        this.updateEmployeeChart();
      });
    },

    async loadData() {
      this.loading = true;
      try {
        const response = await fetch(this.$el.dataset.dataUrl);
        this.chartData = await response.json();
        this.dataPoints = this.chartData.dates.length;

        await this.$nextTick();

        this.initPartnershipsChart();
        this.initNoFeeChart();
        this.initIndustryChart();
        this.initEmployeeChart();

      } catch (error) {
        console.error('Error loading chart data:', error);
        alert(this.$el.dataset.errorMsg || 'Error loading chart data');
      } finally {
        this.loading = false;
      }
    },

    initPartnershipsChart() {
      const ctx = this.$refs.partnershipsChart;
      if (!ctx) return;

      charts.partnerships = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.chartData.dates,
          datasets: [
            {
              label: this.$el.dataset.labelActive,
              data: this.chartData.partnerships.active,
              borderColor: 'rgb(75, 192, 192)',
              backgroundColor: 'rgba(75, 192, 192, 0.1)',
              tension: 0.4,
              fill: true
            },
            {
              label: this.$el.dataset.labelTotal,
              data: this.chartData.partnerships.total,
              borderColor: 'rgb(54, 162, 235)',
              backgroundColor: 'rgba(54, 162, 235, 0.1)',
              tension: 0.4,
              fill: true
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: 'index',
            intersect: false,
          },
          plugins: {
            legend: {
              position: 'top',
            },
            tooltip: {
              callbacks: {
                title: (tooltipItems) => {
                  return new Date(tooltipItems[0].label).toLocaleDateString('de-DE', {
                    year: 'numeric',
                    month: 'long'
                  });
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                precision: 0
              }
            }
          }
        }
      });
    },

    initNoFeeChart() {
      const ctx = this.$refs.noFeeChart;
      if (!ctx) return;

      charts.noFee = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.chartData.dates,
          datasets: [
            {
              label: this.$el.dataset.labelNoFee,
              data: this.chartData.partnerships.no_fee_percentage,
              borderColor: 'rgb(255, 159, 64)',
              backgroundColor: 'rgba(255, 159, 64, 0.1)',
              tension: 0.4,
              fill: true
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'top',
            },
            tooltip: {
              callbacks: {
                title: (tooltipItems) => {
                  return new Date(tooltipItems[0].label).toLocaleDateString('de-DE', {
                    year: 'numeric',
                    month: 'long'
                  });
                },
                label: (context) => {
                  return context.dataset.label + ': ' + context.parsed.y.toFixed(2) + '%';
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              max: 100,
              ticks: {
                callback: (value) => value + '%'
              }
            }
          }
        }
      });
    },

    initIndustryChart() {
      const ctx = this.$refs.industryChart;
      if (!ctx) return;

      // Shades of blue - darker to lighter for stacked visualization
      const colors = [
        'rgb(13, 71, 161)',    // darkest
        'rgb(25, 118, 210)',
        'rgb(30, 136, 229)',
        'rgb(66, 165, 245)',
        'rgb(100, 181, 246)',
        'rgb(144, 202, 249)',
        'rgb(187, 222, 251)',
        'rgb(206, 232, 252)',
        'rgb(227, 242, 253)',
        'rgb(240, 249, 255)'   // lightest
      ];

      const datasets = this.chartData.industries.map((industry, index) => ({
        label: industry.label,
        data: industry.data,
        borderColor: colors[index % colors.length],
        backgroundColor: colors[index % colors.length].replace('rgb', 'rgba').replace(')', ', 0.5)'),
        tension: 0.4
      }));

      charts.industry = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.chartData.dates,
          datasets: datasets
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: 'index',
            intersect: false,
          },
          plugins: {
            legend: {
              position: 'top',
            },
            tooltip: {
              callbacks: {
                title: (tooltipItems) => {
                  return new Date(tooltipItems[0].label).toLocaleDateString('de-DE', {
                    year: 'numeric',
                    month: 'long'
                  });
                }
              }
            }
          },
          scales: {
            y: {
              stacked: false,
              beginAtZero: true,
              ticks: {
                precision: 0
              }
            },
            x: {
              stacked: false
            }
          }
        }
      });
    },

    updateIndustryChart() {
      if (charts.industry) {
        charts.industry.options.scales = {
          y: {
            stacked: this.industryStacked,
            beginAtZero: true,
            ticks: {
              precision: 0
            }
          },
          x: {
            stacked: this.industryStacked
          }
        };
        charts.industry.data.datasets.forEach(dataset => {
          dataset.fill = this.industryStacked;
        });
        charts.industry.update();
      }
    },


    initEmployeeChart() {
      const ctx = this.$refs.employeeChart;
      if (!ctx) return;

      // Shades of green - darker to lighter for stacked visualization
      const colors = [
        'rgb(27, 94, 32)',     // darkest
        'rgb(46, 125, 50)',
        'rgb(67, 160, 71)',
        'rgb(102, 187, 106)',
        'rgb(165, 214, 167)'   // lightest
      ];

      const datasets = this.chartData.employee_sizes.map((size, index) => ({
        label: size.label,
        data: size.data,
        borderColor: colors[index % colors.length],
        backgroundColor: colors[index % colors.length].replace('rgb', 'rgba').replace(')', ', 0.5)'),
        tension: 0.4,
        fill: this.employeeStacked
      }));

      charts.employee = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.chartData.dates,
          datasets: datasets
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: 'index',
            intersect: false,
          },
          plugins: {
            legend: {
              position: 'top',
            },
            tooltip: {
              callbacks: {
                title: (tooltipItems) => {
                  return new Date(tooltipItems[0].label).toLocaleDateString('de-DE', {
                    year: 'numeric',
                    month: 'long'
                  });
                }
              }
            }
          },
          scales: {
            y: {
              stacked: this.employeeStacked,
              beginAtZero: true,
              ticks: {
                precision: 0
              }
            },
            x: {
              stacked: this.employeeStacked
            }
          }
        }
      });
    },

    updateEmployeeChart() {
      if (charts.employee) {
        charts.employee.options.scales = {
          y: {
            stacked: this.employeeStacked,
            beginAtZero: true,
            ticks: {
              precision: 0
            }
          },
          x: {
            stacked: this.employeeStacked
          }
        };
        charts.employee.data.datasets.forEach(dataset => {
          dataset.fill = this.employeeStacked;
        });
        charts.employee.update();
      }
    },

  }
};

Alpine.start();
